// extracted by css-extract-rspack-plugin
export default {"boopIcon":"boopIcon-bhCqYd","smsIcon":"smsIcon-a9k8Cs","htmlAllowedIcon":"htmlAllowedIcon-TAjciG"};